<template>
	<div class="ena">
		<div class="ena__elm">
			<div class="ena__elm-alert">Нет доступа к этому инстансу.</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class ErrorNoAccess extends Vue {}
</script>

<style scoped lang="scss">
.ena {
	padding: 24px;
	background: rgb(255, 255, 255);
	border-radius: 12px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);

	&__elm {
		display: flex;
		justify-content: center;
	}

	&__elm-alert {
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
	}

	@media screen and (max-width: 768px) {
		&__elm-alert {
			font-size: 22px;
		}
	}
}
</style>
